import { render, staticRenderFns } from "./BusinessTypeClients.vue?vue&type=template&id=51591d2c&"
import script from "./BusinessTypeClients.vue?vue&type=script&lang=js&"
export * from "./BusinessTypeClients.vue?vue&type=script&lang=js&"
import style0 from "./BusinessTypeClients.vue?vue&type=style&index=0&id=51591d2c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports